import { action, computed, makeObservable, observable } from 'mobx';

export default class ExpansionState {
  @observable.ref public expandedIds = new Set<string>();

  public constructor(private readonly getExpandableIds: () => string[]) {
    makeObservable(this);
  }

  @computed
  public get areAllExpanded(): boolean {
    const expandableIds = this.getExpandableIds();
    return expandableIds.length > 0 && this.expandedIds.size === expandableIds.length;
  }

  @action
  public collapseAll(): void {
    this.setExpanded([]);
  }

  @action
  public expandAll(): void {
    this.setExpanded(this.getExpandableIds());
  }

  @action.bound
  public setExpanded(ids: Iterable<string>): void {
    const expandable = new Set(this.getExpandableIds());
    this.expandedIds = new Set([...ids].filter((id) => expandable.has(id)));
  }

  @action.bound
  public toggle(id: string): void {
    if (!this.getExpandableIds().includes(id)) {
      return;
    }

    const next = new Set(this.expandedIds);

    if (!next.delete(id)) {
      next.add(id);
    }

    this.expandedIds = next;
  }
}
